import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f9ac95c2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "item"
};
const _hoisted_2 = {
  class: "top"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "progress-box"
};
const _hoisted_5 = {
  class: "bottom"
};
const _hoisted_6 = {
  class: "recommend_cont"
};
const _hoisted_7 = {
  key: 0,
  class: "recommend_cont_info"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title_icon"
}, "众筹", -1));
const _hoisted_9 = {
  key: 1,
  class: "recommend_cont_info"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title_icon title_icon_mall"
}, "预售", -1));
const _hoisted_11 = {
  key: 2,
  class: "recommend_cont_info recommend_cont_info_kuji"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title_icon title_icon_kuji"
}, "幸运商店", -1));
const _hoisted_13 = {
  key: 3
};
const _hoisted_14 = {
  key: 0,
  class: "tail"
};
const _hoisted_15 = {
  key: 1
};
const _hoisted_16 = {
  key: 1,
  class: "tail tail_mall"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_progress = _resolveComponent("van-progress");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [$props.item.card_info.rank_info && $props.item.card_info.rank_info.rank_tag_name ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "rank_info",
    onClick: _cache[0] || (_cache[0] = _withModifiers($event => $options.goCategoryList($props.item.card_info.rank_info), ["stop"]))
  }, _toDisplayString($props.item.card_info.rank_info && $props.item.card_info.rank_info.rank_tag_name), 1)) : _createCommentVNode("", true), _createElementVNode("img", {
    src: _ctx.$imgUrlFilter($props.item.card_info && $props.item.card_info.img_url, 350, 350) || $data.default_img,
    onerror: "javascript:this.src='https://s.moimg.net/m/img/placeholder/default_1x1@2x.png'"
  }, null, 8, _hoisted_3), _createElementVNode("div", _hoisted_4, [$props.item.type == 'pro' && $props.item.status_code != 4 && $props.item.status_code != 1 && $props.item.card_info && $props.item.card_info.progress != '0%' && $props.item.card_info.progress != '0.00%' ? (_openBlock(), _createBlock(_component_van_progress, {
    key: 0,
    color: "#00C4A1",
    "trank-color": "#F2F2F2",
    "show-pivot": false,
    percentage: $props.item.card_info && $props.item.card_info.progress ? Number($props.item.card_info.progress.replace(/%/ig, '')) > 100 ? 100 : Number($props.item.card_info.progress.replace(/%/ig, '')) : ''
  }, null, 8, ["percentage"])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [$props.item.type == 'pro' && $props.item.card_info.status_code != 4 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_hoisted_8, _createTextVNode(_toDisplayString($props.item.card_info.name), 1)])) : $props.item.type == 'mall_pro' && $props.item.card_info.presale_type > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_hoisted_10, _createTextVNode(_toDisplayString($props.item.card_info.name), 1)])) : $props.item.type == 'kuji' ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_hoisted_12, _createTextVNode(_toDisplayString($props.item.card_info.name), 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString($props.item.card_info && $props.item.card_info.name), 1))]), $props.item.type == 'pro' ? (_openBlock(), _createElementBlock("div", _hoisted_14, [![1, 4].includes($props.item.card_info.status_code) ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createElementVNode("span", null, "已筹 ¥" + _toDisplayString($props.item.card_info && $props.item.card_info.backer_money), 1), _createElementVNode("span", null, "支持者 " + _toDisplayString($props.item.card_info && $props.item.card_info.backer_count), 1)], 64)) : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString($props.item.card_info && $props.item.card_info.bullish_count) + "人看好", 1))])) : $props.item.type == 'mall_pro' || $props.item.type == 'kuji' ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("div", {
    class: _normalizeClass(['price', {
      'price-kuji': $props.item.type == 'kuji'
    }])
  }, "￥" + _toDisplayString($props.item.card_info.price), 3), _createElementVNode("span", null, _toDisplayString($props.item.card_info && $props.item.card_info.like_user_num && $props.item.card_info.like_user_num > 0 ? $props.item.card_info.like_user_num + '人想要' : ''), 1)])) : _createCommentVNode("", true)])]);
}